<div class="add-stripe-acc-container" *ngIf="loaded else loading">
  <form [formGroup]="accountDetails" (ngSubmit)="updateAccount(accountDetails)">
    <h1 style="color:#444444!important;padding-top: 0px;font-size: 42px!important;text-align: left;width: 100%;">Stripe
      Account</h1>
    <!-- <label>Update Stripe Account</label> -->
    <div class="form-group row">
      <!-- <div (mouseover)="isHovered = !isHovered" (mouseout)="isHovered = !isHovered" class="id-container" [ngStyle]="{
        'background': 'url(' + fileFront + ')', 'background-size': '100% 100%'
      }"> -->

      <!-- <div [hidden]="isHovered">
        <i (click)="uploadFront.click()" class="fa fa-camera upload-button" aria-hidden="true"></i>
      </div>
      <input type="file" [hidden]="true" (change)="uploadIdFront($event.target)" formControlName="frontId"
        #uploadFront /> -->
      <!-- <div *ngIf="accountDetails.controls.lname.touched || accountDetails.controls.fname.touched || accountDetails.controls.frontId.hasError('general')">
        <small *ngIf="accountDetails.controls.frontId.hasError('required')" class="text-danger"
          >ID is Required</small
        >
        <small *ngIf="accountDetails.controls.frontId.hasError('general')" class="text-danger"
          >{{accountDetails.controls.frontId.getError('general')}}</small
        >
      </div> -->
    </div>
    <div class="form-group row">
      <div class="col-5">
        <mat-form-field appearance="fill">
          <mat-label>First Name</mat-label>
          <input matInput type="text" placeholder="First Name" formControlName="fname" />
        </mat-form-field>
        <div *ngIf="accountDetails.controls.fname.touched">
          <small *ngIf="accountDetails.controls.fname.hasError('required')" class="text-danger">First Name is
            required</small>
        </div>
      </div>
      <div class="col-7">
        <mat-form-field>
          <input matInput type="text" class="form-control" placeholder="Last Name" formControlName="lname" />
        </mat-form-field>
        <div *ngIf="accountDetails.controls.lname.touched">
          <small *ngIf="accountDetails.controls.lname.hasError('required')" class="text-danger">Last Name is
            required</small>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <br>
      <div class="col-12">
        <label style="font-size: 12px;opacity: 0.6;">Gender</label>
      </div>
      <div class="col-12" style="padding-bottom: 10px;">
        <mat-radio-group formControlName="gender">
          <mat-radio-button value="male">Male</mat-radio-button>
          <mat-radio-button style="padding-left:10px;" value="female">Female</mat-radio-button>
        </mat-radio-group>
        <div style="position: relative;margin-top: 8px;"
          *ngIf="accountDetails.controls.bDay.touched || accountDetails.controls.address.touched || accountDetails.controls.email.touched">
          <small *ngIf="accountDetails.controls.gender.hasError('required')" class="text-danger">Gender is
            required</small>
        </div>
      </div>
      <!-- <input type="radio" class="form-control" formControlName="gender" value="male"> Male
      <input type="radio" class="form-control" formControlName="gender" value="female"> Female -->

    </div>
    <div class="form-group col-10" style="padding: 0px;">
      <div class="row">
        <mat-form-field appearance="fill">
          <mat-label>Choose a date</mat-label>
          <mat-datepicker #picker></mat-datepicker>
          <input matInput [matDatepicker]="picker" formControlName="bDay">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        </mat-form-field>
      </div>
    </div>
    <!-- <div class="form-group col-5 row">
      <mat-form-field class="w-100">
        <input type="text" class="form-control" matInput [matDatepicker]="picker" placeholder="Birthday"
          formControlName="bDay" [max]="maxDate" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <div *ngIf="accountDetails.controls.bDay.touched">
        <small *ngIf="accountDetails.controls.bDay.hasError('required')" class="text-danger">Birthday is
          required</small>
      </div>
    </div> -->

    <div class="form-group row">
      <div class="col-7">
        <mat-form-field>
          <input matInput type="email" class="form-control" placeholder="E-mail Address" formControlName="email" />
        </mat-form-field>
        <div *ngIf="accountDetails.controls.email.touched">
          <small *ngIf="accountDetails.controls.email.hasError('required')" class="text-danger">E-mail Address is
            required</small>
          <small *ngIf="accountDetails.controls.email.hasError('email')" class="text-danger">Please Enter a Valid
            E-Mail
            Address</small>
        </div>
      </div>
      <div class="col-5">
        <mat-form-field>
          <input matInput type="text" class="form-control" placeholder="Phone Number" formControlName="phoneNum" />
        </mat-form-field>
        <!-- <div *ngIf="accountDetails.controls.fname.touched">
          <small *ngIf="accountDetails.controls.fname.hasError('required')" class="text-danger">First Name is
            required</small>
        </div> -->
      </div>
    </div>

    <div class="form-group row" id="personalId">
      <div class="col-7">
        <mat-form-field>
          <input matInput type="text" class="form-control" placeholder="Personal Identification" formControlName="p_id"
            [matTooltipPosition]="'above'"
            matTooltip="National Registration Identity Card (NRIC) or Foreign Identification Number (FIN)" />
        </mat-form-field>
        <div *ngIf="accountDetails.controls.p_id.touched">
          <small *ngIf="accountDetails.controls.p_id.hasError('required')" class="text-danger">Personal Identification
            is
            required</small>
          <small *ngIf="accountDetails.controls.p_id.hasError('invalid')" class="text-danger">Please Enter a Valid
            Personal ID</small>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-7">
        <mat-form-field>
          <input matInput type="text" class="form-control" placeholder="Address" formControlName="address" />
        </mat-form-field>
        <div *ngIf="accountDetails.controls.address.touched">
          <small *ngIf="accountDetails.controls.address.hasError('required')" class="text-danger">Address is
            required</small>
        </div>
      </div>
      <div class="col-5">
        <mat-form-field>
          <input matInput type="text" class="form-control" placeholder="Postal Code" formControlName="postal_code" />
        </mat-form-field>
        <div *ngIf="accountDetails.controls.postal_code.touched">
          <small *ngIf="accountDetails.controls.postal_code.hasError('required')" class="text-danger">Postal Code is
            required</small>
        </div>
      </div>
    </div>

    <button type="submit" class="btn-rntIt-lg btn btn-success btn-block form-group" [disabled]="!accountDetails.valid">
      Update Details
    </button>
    <!-- <p>By registering your account, you agree to our <a href="#tos-acceptance">Services Agreement</a> and the <a
        target="_blank" href="https://stripe.com/connect-account/legal">Stripe Connected Account Agreement</a>.</p> -->
  </form>
</div>

<ng-template #loading>
  <div class="loading-wrap">
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</ng-template>